import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { rootOf } from "./helpers";

function Choice({ value, title, hint, testid }) {
  return (
    <label className="flex cursor-pointer items-start gap-2.5 rounded-lg border border-slate-200 p-3 transition-colors hover:border-sky-300 has-[[data-state=checked]]:border-sky-500 has-[[data-state=checked]]:bg-sky-50/60">
      <RadioGroupItem value={value} className="mt-0.5" data-testid={testid} />
      <span className="text-sm text-slate-800">{title}{hint && <span className="block text-xs text-slate-500">{hint}</span>}</span>
    </label>
  );
}

export default function WizardDomainStep({ f, setF }) {
  const { root, kind } = rootOf(f.domain);
  const pair = root && kind !== "sub";
  const www = `www.${root}`;
  const primaryHost = !pair ? f.domain.trim() : f.primary === "www" ? www : root;
  return (
    <div className="space-y-5">
      <div>
        <Label className="text-xs">Dominio del cliente</Label>
        <Input autoFocus className="mt-1 font-mono" value={f.domain} placeholder="www.cliente.it" onChange={(e) => setF({ ...f, domain: e.target.value })} data-testid="domain-wizard-input" />
        <p className="mt-1 text-[11px] text-slate-500">Solo il nome, senza https:// (es. www.cliente.it oppure shop.cliente.it). Il cliente deve poter modificare i DNS del dominio.</p>
      </div>
      {pair && (
        <div className="space-y-2">
          <p className="text-xs font-medium text-slate-700">Indirizzo principale</p>
          <RadioGroup value={f.primary} onValueChange={(v) => setF({ ...f, primary: v, variant: v === "www" ? "registrar" : "cloudflare" })} className="grid gap-2 sm:grid-cols-2">
            <Choice value="www" title={<span className="font-mono">{www}</span>} hint="Consigliato: funziona con tutti i registrar" testid="domain-wizard-primary-www" />
            <Choice value="apex" title={<span className="font-mono">{root}</span>} hint="Solo se il DNS del cliente accetta CNAME/ALIAS alla radice" testid="domain-wizard-primary-apex" />
          </RadioGroup>
        </div>
      )}
      {pair && (
        <div className="space-y-2">
          <p className="text-xs font-medium text-slate-700">Indirizzo {f.primary === "www" ? `senza www (${root})` : `con www (${www})`}</p>
          <RadioGroup value={f.variant} onValueChange={(v) => setF({ ...f, variant: v })} className="grid gap-2">
            {f.primary === "www" && <Choice value="registrar" title="Inoltro dal registrar verso www (consigliato)" hint={`Si imposta presso il registrar; lo Studio controlla che ${root} rimandi davvero a ${www}. Usa 1 nome su 100.`} testid="domain-wizard-variant-registrar" />}
            <Choice value="cloudflare" title="Secondo nome su Cloudflare con rimando 301" hint={f.primary === "www" ? `HTTPS anche su ${root}, ma solo se il DNS accetta CNAME/ALIAS alla radice. Usa 2 nomi su 100.` : `${www} rimanda a ${root}. Usa 2 nomi su 100.`} testid="domain-wizard-variant-cloudflare" />
            <Choice value="none" title="Nessuna variante" hint="Solo l'indirizzo principale" testid="domain-wizard-variant-none" />
          </RadioGroup>
        </div>
      )}
      {root && kind === "sub" && <p className="rounded-lg bg-slate-50 px-3 py-2 text-xs text-slate-600" data-testid="domain-wizard-sub-note">Sottodominio: un solo nome ({primaryHost}), senza varianti.</p>}
      <label className="flex items-start gap-2.5 text-sm text-slate-700">
        <Checkbox checked={f.prevalidate} onCheckedChange={(v) => setF({ ...f, prevalidate: !!v })} className="mt-0.5" data-testid="domain-wizard-prevalidate" />
        <span>Il sito del cliente è già online su questo indirizzo<span className="block text-xs text-slate-500">Prima si aggiungono i record TXT e il certificato viene emesso in anticipo, poi si sposta il CNAME: nessuna interruzione.</span></span>
      </label>
    </div>
  );
}
